import useAsyncData from "../../../../hooks/use-async-data";
import contractsService from "../../contracts.service";
import ContractsTaxiDriverDetails from "./contracts-taxi-driver-details";
import ContractsTaxiDriverDetailsParams from "./contracts-taxi-driver-details-params";

const useContractsTaxiDriverDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<ContractsTaxiDriverDetails | null>(null);

  const load = async (
    params: ContractsTaxiDriverDetailsParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await contractsService.getTaxiDriverContractDetails(
        params,
        signal,
      );

      setData(data);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useContractsTaxiDriverDetails;
